import * as React from "react";
import styled, { css } from "styled-components";
import { flexRender } from "@tanstack/react-table";
import { getPinnedCellClassName } from "components/bootstrap/Table";
import {
  columnTransformVar,
  columnOpacityVar,
  columnWidthVar,
  columnTransition,
  displayScrollRightIndicatorVar
} from "components/common/EntityDataTable/CSSVariables";
import { ACTIONS_COL_ID } from "components/common/EntityDataTable/Constants";
import ScrollShadow from "theme/box-shadows/ScrollShadow";
const Thead = styled.thead(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
  `
);
export const Th = styled.th(
  ({ $colId, $hidePadding, $pinningPosition, theme }) => css`
    width: var(${columnWidthVar($colId)});
    opacity: var(${columnOpacityVar($colId)}, 1);
    transform: var(${columnTransformVar($colId)}, translate3d(0, 0, 0));
    background-color: ${theme.colors.table.head.background};
    transition: var(${columnTransition()}, none);
    height: 100%; // required to be able to use height: 100% in child elements
    ${$pinningPosition ? css`
          position: sticky;
          ${$pinningPosition === "left" ? "left" : "right"}: 0;
        ` : ""}

    ${$hidePadding && css`
      && {
        padding: 0;
      }
    `}

    ${$colId === ACTIONS_COL_ID && css`
      position: sticky;
      ${ScrollShadow("left")}
      &::before {
        display: var(${displayScrollRightIndicatorVar}, none);
      }
    `}
  `
);
const TableHeaderCell = ({ header }) => {
  const columnMeta = header.column.columnDef.meta;
  return /* @__PURE__ */ React.createElement(
    Th,
    {
      key: header.id,
      colSpan: header.colSpan,
      $colId: header.column.id,
      $hidePadding: columnMeta == null ? void 0 : columnMeta.hideCellPadding,
      className: getPinnedCellClassName(!!header.column.getIsPinned(), false),
      $pinningPosition: header.column.getIsPinned()
    },
    header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())
  );
};
const TableHead = ({ headerGroups }) => /* @__PURE__ */ React.createElement(Thead, null, headerGroups.map((headerGroup) => /* @__PURE__ */ React.createElement("tr", { key: headerGroup.id }, headerGroup.headers.map((header) => /* @__PURE__ */ React.createElement(TableHeaderCell, { key: header.id, header })))));
export default TableHead;
